export const environment = {
  production: false,
  DOMAINS: [
    { name: 'Botox Javea', domainName: 'https://www.botoxjavea.com' },
    { name: 'Zen Smile Spa', domainName: 'https://www.zensmilespa.es' },
    { name: 'DentistJavea.com', domainName: 'https://www.dentistjavea.com' },
    { name: 'Spajavea.es', domainName: 'https://www.spajavea.es' },
    { name: 'esteticajavea.com', domainName: 'https://www.esteticajavea.com' },
  ]
};

